/**
 * Maps a list of raw transaction objects from the backend to a standardized frontend format.
 * Used for displaying transactions in tables and detail panels.
 * 
 * @param {Array} rawTransactions - The array of raw transaction records from the API
 * @returns {Array} - The array of standardized transaction objects
 */
export const mapGlobalTransactions = (rawTransactions) => {
  return (rawTransactions || []).filter(Boolean).map((t) => ({
    id: t.id,
    providerTransactionId: t.provider_transaction_id,
    type: t.type?.toLowerCase(),
    status: (t.status || "").toLowerCase(),
    amount: Number(t.amount ?? 0),
    feeAmount: Number(t.fee_amount ?? 0),
    netAmount: Number(t.net_amount ?? 0),
    currency: t.currency,
    country: t.country,
    paymentMethod: t.payment_method,
    providerId: t.provider_id,
    providerCode: t.provider?.code,
    processorBankcode: t.processor_bankcode,
    payoutType: t.payout_type,
    platformName: t.platformName,
    ipAddress: t.ip_address,
    customerName: t.customer_name || undefined,
    customerEmail: t.customer_email || undefined,
    customerPhone: t.customer_phone || undefined,
    provider: t.provider ? {
      name: t.provider.name,
      id: t.provider.id,
      code: t.provider.code,
      status: t.provider.status,
    } : null,
    merchant: {
      name: t.merchant_name,
      id: t.merchant_id,
      code: t.merchant_code,
    },
    reseller: t.reseller_id ? {
      name: t.reseller_name,
      id: t.reseller_id,
      code: t.reseller_code,
    } : null,
    engine: t.engine_id ? {
      name: t.engine_name,
      id: t.engine_id,
      code: t.engine_code,
    } : null,
    callbackStatus: t.callback_status || undefined,
    callbackAttempts: t.callback_attempts,
    callbackReceivedAt: t.callback_received_at,
    callbackResponse: t.callback_response,
    expiresAt: t.expires_at,
    processedAt: t.processed_at || undefined,
    completedAt: t.completed_at || undefined,
    apiResponse: t.api_response,
    metadata: t.metadata,
    createdAt: t.createdAt,
    updatedAt: t.updatedAt,
  }));
};
